export const MULTILEVEL_CF_TYPE = 'multilevel-cascading-custom-field-type';
export const REGEX_CF_TYPE = 'custom-field-regex-type';
export const JIRA_EXPRESSION_CF_TYPE = 'custom-field-jira-expression-type';

export const DOCUMENTATION_LINK = 'https://docs.appsvio.com/multilevel-cascading-select';
